import { ApplicationType } from '@testsigmainc/constants';
import { Icon, useTranslation } from '@testsigma/atoms';
import classNames from 'classnames';

interface OnboardingAplicationTileProps {
  icon: string;
  type: ApplicationType;
  i18n: string;
  isSelected: boolean;
  onSelect: (type: ApplicationType) => void;
}

export const OnboardingAplicationTile: React.FC<
  OnboardingAplicationTileProps
> = ({ icon, type, i18n, isSelected, onSelect }) => {
  const { t } = useTranslation();
  return (
    <div
      onClick={() => onSelect(type)}
      className='w-[100px] items-center justify-center flex-col cursor-pointer'
    >
      <div className='flex justify-center items-center w-full'>
        <div
          className={classNames(
            'w-16 h-16 shadow-md rounded-2xl flex items-center justify-center',
            isSelected ? 'text-primary-500' : 'text-secondary-500',
          )}
        >
          <Icon name={icon} className='text-2xl' />
        </div>
      </div>

      <div
        className={classNames(
          'felx items-center justify-center text-center text-sm font-normal leading-5 flex-wrap mt-4',
          isSelected ? 'text-primary-500' : 'text-secondary-500',
        )}
      >
        {t(i18n)}
      </div>
    </div>
  );
};
